import { Component, ElementRef } from '@angular/core';
import { BlockableUI } from 'primeng/api';

@Component({
  selector: 'app-blockable-div',
  template: ` <div class=""><ng-content></ng-content></div> `,
})
export class BlockableDivComponent implements BlockableUI {

  constructor(private elementRef: ElementRef) { }

  getBlockableElement(): HTMLElement {
    return this.elementRef.nativeElement.children[0];
  }
}
